module.exports = __webpack_public_path__ + "img/chevron_left.36570a62.svg";